import { render, staticRenderFns } from "./widgetProfile.vue?vue&type=template&id=e23e1730&scoped=true"
import script from "./widgetProfile.vue?vue&type=script&lang=js"
export * from "./widgetProfile.vue?vue&type=script&lang=js"
import style0 from "./widgetProfile.vue?vue&type=style&index=0&id=e23e1730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23e1730",
  null
  
)

export default component.exports